import React , {useEffect } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import GlobalStyles from 'src/components/GlobalStyles';
import ScrollReset from 'src/components/ScrollReset';
//import CookiesNotification from 'src/components/CookiesNotification';
import GoogleAnalytics from 'src/components/GoogleAnalytics';
//import SettingsNotification from 'src/components/SettingsNotification';
import InternetConnection from 'src/components/InternetConnection';
import { AuthProvider } from 'src/contexts/JWTAuthContext';
import useSettings from 'src/hooks/useSettings';
import { createTheme } from 'src/theme';
import routes, { renderRoutes } from 'src/routes';
import { StreamProvider } from 'src/contexts/StreamContext';
import { ImportCompanySetupProvider } from 'src/contexts/ImportForCompanyContext';
import { ReportProvider } from 'src/contexts/ReportContext';
import { DashboardProvider } from 'src/contexts/DashboardContext';
import { FeeSetupProvider } from 'src/contexts/ImportSetupContext';
import { ModalExecutionContextProvider } from 'src/contexts/ModalExecution';
import { YearProvider } from 'src/contexts/YearContext';
import useAuth from 'src/hooks/useAuth';
import Cookies from 'js-cookie';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const history = createBrowserHistory();
//console.log(navigator.onLine);
const App = () => {
  const { settings } = useSettings();
  const {logout} = useAuth()
  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme
  });

  const MAX_WINDOWS = 1;
const channel = new BroadcastChannel("window_tracker");

let windowCount = 0;

channel.addEventListener("message", (event) => {
    if (event.data.type === "update_count") {
        windowCount = event.data.count;
    }
    if (windowCount >= MAX_WINDOWS) {
      logout()
      window.localStorage.removeItem('session');
      window.localStorage.removeItem('username');
        Cookies.remove('accessToken');
          Cookies.remove('rfsrt');
          Cookies.remove('idToken');
         alert("Only 1 window is allowed!");
         window.open('', '_self');
         window.close();
   
       
    }
});

function notifyOpen() {
    channel.postMessage({ type: "open" });
}   

function notifyClose() {
    channel.postMessage({ type: "close" });
}

channel.addEventListener("message", (event) => {
    if (event.data.type === "open") {
        windowCount++;
        channel.postMessage({ type: "update_count", count: windowCount });
    } else if (event.data.type === "close") {
        windowCount = Math.max(0, windowCount - 1);
        channel.postMessage({ type: "update_count", count: windowCount });
    }
});

window.addEventListener("load", notifyOpen);
window.addEventListener("beforeunload", notifyClose);

  useEffect(() => {
    // Disable Right Click
    document.addEventListener("contextmenu", (event) => event.preventDefault());
  
    // Disable F12 and other DevTools shortcuts
    document.addEventListener("keydown", (event) => {
      if (
        event.key === "F12" || 
        (event.ctrlKey && event.shiftKey && ["I", "J", "C"].includes(event.key)) ||
        (event.ctrlKey && event.key === "U")
      ) {
        event.preventDefault();
      }
    });
  
    return () => {
      document.removeEventListener("contextmenu", (event) =>
        event.preventDefault()
      );
      document.removeEventListener("keydown", (event) => {
        if (
          event.key === "F12" ||
          (event.ctrlKey && event.shiftKey && ["I", "J", "C"].includes(event.key)) ||
          (event.ctrlKey && event.key === "U")
        ) {
          event.preventDefault();
        }
      });
    };
  }, []);

  useEffect(() => {
    // 1. Detect DevTools on Load
    const detectDevTools = () => {
      const element = new Image();
      Object.defineProperty(element, "id", {
        get: function () {
          alert("Tools Detected1! Closing the page.");
          window.location.href = "about:blank"; 
        },
      });
      //console.log(element);
    };
  
    // 2. Freeze App if DevTools is Open
    let start = performance.now();
    let checkDevTools = () => {
      let end = performance.now();
      if (end - start > 100) { 
        alert("Tools Detected2! Closing the app.");
        window.stop(); 
        document.body.innerHTML = ""; 
      }
      start = performance.now();
      requestAnimationFrame(checkDevTools);
    };
  
    // 3. Debugger Trap
    const disableDevTools = () => {
      setInterval(() => {
        debugger;
      }, 100);
    };
  
    // 4. Block DevTools if Open at Start
    const isDevToolsOpen = () => {
      let widthThreshold = window.outerWidth - window.innerWidth > 160;
      let heightThreshold = window.outerHeight - window.innerHeight > 160;
      if (widthThreshold || heightThreshold) {
        alert("Tools Detected3! Redirecting...");
        window.location.href = "about:blank";
      }
    };
  
    // Run all methods
    const interval1 = setInterval(detectDevTools, 1000);
     //const interval2 = setInterval(isDevToolsOpen, 1000);
    disableDevTools();
    //checkDevTools();
  
    return () => {
      clearInterval(interval1);
      // clearInterval(interval2);
    };
  }, []);

  
  return (
    
    <>
   
    <ThemeProvider theme={theme}>
      
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider dense={false} maxSnack={1}>
            <Router history={history}>
              {/* <AuthProvider>
              <DashboardProvider>

                <ImportCompanySetupProvider>
                  <ModalExecutionContextProvider> */}
                    {/* <ReportProvider>
                      <FeeSetupProvider>
                      <StreamProvider>
                      <YearProvider> */}
                          <GlobalStyles />
                          <ScrollReset />
                          <GoogleAnalytics />
                          {/* <CookiesNotification />
                <SettingsNotification /> */}
                          <InternetConnection />
                          {renderRoutes(routes)}
                      {/* </YearProvider>
                      </StreamProvider>
                      </FeeSetupProvider>
                    </ReportProvider> */}
                    {/* </ModalExecutionContextProvider>
                  
                </ImportCompanySetupProvider>
                </DashboardProvider> */}
              {/* </AuthProvider> */}
            </Router>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
    
    </>
  );
};

export default App;
